var Loading = /** @class */ (function () {
    function Loading(config) {
        /**
         * loading动画的css地址
         */
        this.cssURL = 'https://res.cdn.changbaimg.com/-/a18a53c59403dcad/loading.css';
        /**
         * loading的配置
         */
        this.config = this.createDefaultLoadingConfig();
        /**
         * 用于关闭loading的定时器
         */
        this.timer = null;
        this.config = config || this.createDefaultLoadingConfig();
        // 初始化的时候就插入样式，为的是loading第一次展示的时候避免还没有
        this.insertStyleSheet();
    }
    /**
     * 生成默认的loading配置
     * @returns
     */
    Loading.prototype.createDefaultLoadingConfig = function () {
        return {
            duration: 3000,
            message: '加载中',
        };
    };
    /**
     * 展示loading动画
     * @param message loading动画显示的内容
     * @param duration loading动画在多久后关闭
     */
    Loading.prototype.show = function (message, duration) {
        var loadingEle = document.querySelector('#loading');
        if (!loadingEle) {
            this.insertElement(message);
            loadingEle = document.querySelector('#loading');
        }
        loadingEle.style.display = 'block';
        var messageEle = loadingEle.querySelector('.weui_toast_content');
        messageEle.innerHTML = message;
        // 3S之后自动关闭
        this.timer = setTimeout(this.hide.bind(this), duration || this.config.duration);
    };
    /**
     * 关闭loading动画
     * @returns
     */
    Loading.prototype.hide = function () {
        var loadingEle = document.querySelector('#loading');
        if (!loadingEle) {
            return;
        }
        loadingEle.style.display = 'none';
        this.clearTimer();
    };
    Loading.prototype.clearTimer = function () {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    };
    /**
     * 向DOM中插入loading动画所需样式
     */
    Loading.prototype.insertStyleSheet = function () {
        var id = 'loading-style-node';
        if (document.querySelector('#' + id)) {
            return;
        }
        var loadingStyleNode = document.createElement('link');
        loadingStyleNode.id = id;
        loadingStyleNode.type = 'text/css';
        loadingStyleNode.rel = 'stylesheet';
        loadingStyleNode.href = this.cssURL;
        document.body.appendChild(loadingStyleNode);
    };
    /**
     * 向DOM节点中插入loading节点
     * @param message loading动画展示的文本
     */
    Loading.prototype.insertElement = function (message) {
        var content = "\n      <div class=\"weui_mask_transparent\"></div>\n      <div class=\"weui_toast\">\n        <div class=\"weui_loading\">\n          <div class=\"weui_loading_leaf weui_loading_leaf_0\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_1\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_2\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_3\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_4\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_5\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_6\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_7\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_8\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_9\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_10\"></div>\n          <div class=\"weui_loading_leaf weui_loading_leaf_11\"></div>\n        </div>\n        <p class=\"weui_toast_content\">\n          ".concat(message || this.config.message, "\n        </p>\n      </div>");
        var wrapperEle = document.createElement('div');
        wrapperEle.classList.add('weui_loading_toast');
        wrapperEle.id = 'loading';
        wrapperEle.innerHTML = content;
        document.body.appendChild(wrapperEle);
    };
    return Loading;
}());
export { Loading };
